import Vue from 'vue'
import App from './App.vue'
import Sign from './Components/Sign.vue'
import Join from './Components/Join.vue'
import store from './store'
import i18n from './config/i18n'
Vue.use(i18n)

import firebase from "firebase/app";
import "firebase/auth";

// İmza linki: https://uygulaman/#/sign/<token>
// Hash kullanıyoruz — sunucuda ayrı bir yönlendirme kuralı gerekmiyor.
const signMatch = window.location.hash.match(/^#\/sign\/([A-Za-z0-9]+)/);
const joinMatch = window.location.hash.match(/^#\/(?:davet|join)\/([A-Za-z0-9]+)/);

if (signMatch) {
  // İmzalayanın uygulamada hesabı olmayabilir, o yüzden sayfayı BEKLEMEDEN
  // mount ediyoruz — Firebase kapısının arkasında kalmamalı.
  new Vue({
    store,
    render: h => h(Sign, { props: { signToken: signMatch[1] } })
  }).$mount("#app");

  // Yine de oturumu dinliyoruz: imzalayan kurum içinden biriyse
  // profilindeki kayıtlı imza hazır gelsin. Sayfa buna bağlı değil,
  // oturum yoksa hiçbir şey değişmiyor.
  firebase.auth().onAuthStateChanged(user => {
    store.commit('setAuthUser', user)
  })

} else if (joinMatch) {
  // Davet sayfası oturum gerektiriyor ama davetli henüz giriş yapmamış
  // olabilir; Firebase kapısını açık tutup sayfayı kendisi yönetiyor.
  let joinApp;

  firebase.auth().onAuthStateChanged(user => {
    store.commit('setAuthUser', user)

    if (!joinApp) {
      joinApp = new Vue({
        store,
        render: h => h(Join, { props: { inviteToken: joinMatch[1] } })
      }).$mount("#app")
    }
  })

} else {
  let app;

  firebase.auth().onAuthStateChanged(user => {

    store.commit('setAuthUser', user)

    if (!app) {
      app = new Vue({
        store,
        render: h => h(App)
      }).$mount("#app")
    }

  })
}


// WEBPACK FOOTER //
// ./src/main.js